import React from 'react';

import Framework from "@beardeddevops/react.framework";
import {Collections, Objects} from "components";
import {Button, ButtonGroup} from "reactstrap";
import {API} from "@beardeddevops/react.api";
import Types from "../../../../../constants/Types";
import {withRouter} from "react-router-dom";
import Advertisement from "./Advertisement";
import UniversalModalOverride from "components/UniversalModalOverride";
import Lockable from "components/Lockable";
import {confirmAlert} from "react-confirm-alert";


const breadcrumbsStatic = [
	{
		name: 'Dashboard',
		url: '/',
		icon: 'dashboard',
	},
	{
		name: 'Security Center',
		url: '/security',
		icon: 'shield',
	},
];

class Security extends Lockable {

	constructor(props) {
		super(props);
		this.state.refreshIPBanned = false;
		this.state.refreshIPWhitelisted = false;
		this.state.refreshLoginRecords = false;
		this.state.ipAccessMode = 'blacklist';
		this.state.ipAccessCounts = {
			blacklist: 0,
			whitelist: 0,
		};
		this.state.defaultCenter = {lat: 38.8131638, lng: -96.1420676};
		this.state.defaultZoom = 5;
		this.state.geo_attempts = [];
	}

	componentDidMount() {
		this.preInitMap();

		let teModel = new API.BuildClass(Types.Accounts_Logins._name, API.RequestType.READ);

		teModel.submit(null, API.RequestType.READ_ALL).then((data) => {
			let geo_attempts = data.items.filter(entry => !!entry.geo).map((entry) => {
				/** @type {Accounts_Logins_Object} entry */
				let geo = entry.geo.split(',');
				return {
					lat: Number.parseFloat(geo[0]),
					lng: Number.parseFloat(geo[1]),
					tag: entry.ip,
					icon: 'https://raw.githubusercontent.com/Concept211/Google-Maps-Markers/master/images/marker_red.png'
				}
			});
			this.setState({
				geo_attempts
			}, () => {
				this.initMap();
			})
		});
	}

	preInitMap = () => {
		this.watchID = navigator.geolocation.watchPosition((position) => {
			// Create the object to update this.state.mapRegion through the onRegionChange function
			this.setState({
				defaultCenter: {lat: position.coords.latitude, lng: position.coords.longitude}
			});
		}, () => {

		});
	}

	initMap = () => {
		//potentially google maps with react

		let map_width = $('.map-container').width();
		let map_height = map_width * .66;
		$('#map').height(map_height);

		if (document.getElementById('map')) {
			this.map = new window.google.maps.Map(document.getElementById('map'), {
				zoom: this.state.defaultZoom,
				center: this.state.defaultCenter
			});

			// noinspection JSUnresolvedFunction
			let bounds = new window.google.maps.LatLngBounds();
			for (let i = 0; i < this.state.geo_attempts.length; i++) {
				let geo = this.state.geo_attempts[i];
				// noinspection JSUnresolvedFunction
				new window.google.maps.Marker({
					position: {lat: geo.lat, lng: geo.lng},
					map: this.map,
					title: geo.tag,
					icon: geo.icon
				});
				bounds.extend({lat: geo.lat, lng: geo.lng});
			}
			// noinspection JSUnresolvedFunction
			this.map.fitBounds(bounds);
			this.map.setCenter(bounds.getCenter());

		}
	};

	setIpAccessMode = (ipAccessMode) => {
		const {ipAccessCounts} = this.state;
		if (ipAccessMode === 'blacklist' && ipAccessCounts.whitelist > 0) {
			return;
		}
		if (ipAccessMode === 'whitelist' && ipAccessCounts.blacklist > 0) {
			return;
		}

		this.setState({ipAccessMode});
	};

	reportIpAccessCount = (type, count) => {
		count = Number(count) || 0;
		this.setState(prevState => {
			if (prevState.ipAccessCounts[type] === count) {
				return null;
			}

			const ipAccessCounts = {
				...prevState.ipAccessCounts,
				[type]: count,
			};
			let ipAccessMode = prevState.ipAccessMode;

			if (ipAccessCounts.blacklist > 0 && ipAccessCounts.whitelist === 0) {
				ipAccessMode = 'blacklist';
			}
			if (ipAccessCounts.whitelist > 0 && ipAccessCounts.blacklist === 0) {
				ipAccessMode = 'whitelist';
			}

			return {
				ipAccessCounts,
				ipAccessMode,
			};
		});
	};

	confirmWhitelistIpOpen = () => {
		confirmAlert({
			title: 'Confirm IP Whitelist',
			message: (
				<div>
					<p>
						IP whitelisting restricts FFL Boss account access to only the IP address you provide.
						After a whitelist is added, users will not be able to connect to FFL Boss from any other IP address.
					</p>
					<p>
						Only continue if you are certain the IP address is correct and stable for your network.
					</p>
				</div>
			),
			buttons: [
				{
					label: 'Continue',
					onClick: this.toggle('modalIPWhitelisted')
				},
				{
					label: 'Cancel',
					onClick: () => {}
				}
			]
		});
	};

	renderIpAccessControl = () => {
		const {ipAccessMode, ipAccessCounts} = this.state;
		const hasBlacklist = ipAccessCounts.blacklist > 0;
		const hasWhitelist = ipAccessCounts.whitelist > 0;
		const hasBothModes = hasBlacklist && hasWhitelist;
		const showBlacklist = hasBothModes || ipAccessMode === 'blacklist';
		const showWhitelist = hasBothModes || ipAccessMode === 'whitelist';

		return (
			<div>
				<h4 className="section-title">IP Access Control</h4>
				<ButtonGroup size="sm" style={{marginBottom: '10px'}}>
					<Button
						color={ipAccessMode === 'blacklist' ? 'danger' : 'secondary'}
						outline={ipAccessMode !== 'blacklist'}
						disabled={hasWhitelist}
						onClick={() => this.setIpAccessMode('blacklist')}>
						Blacklist
					</Button>
					<Button
						color={ipAccessMode === 'whitelist' ? 'primary' : 'secondary'}
						outline={ipAccessMode !== 'whitelist'}
						disabled={hasBlacklist}
						onClick={() => this.setIpAccessMode('whitelist')}>
						Whitelist
					</Button>
				</ButtonGroup>

				{hasBothModes && (
					<div className="alert alert-warning" style={{padding: '8px 12px'}}>
						Remove one IP list type before adding more IP access rules.
					</div>
				)}

				<div style={{display: showBlacklist ? 'block' : 'none'}}>
					<h4 className="section-title">
						Banned IP Addresses
						{!hasBothModes && (
							<Button data-id="add-ip_ban" onClick={this.toggle('modalIPBanned')} size={"sm"}
								color="danger" style={{float: 'right', marginRight: '-7px'}}>
								<i className="fa fa-trash"/>&nbsp;&nbsp;Ban IP
							</Button>
						)}
					</h4>
					<UniversalModalOverride
						locations={this.props.locations}
						states={this.props.states}
						history={this.props.history}
						name={"Ban IP"}
						object={Objects.IpBans}
						toggle={this.state.modalIPBanned}
						reportClose={this.reportClose('modalIPBanned')}
						afterSave={() => {
							this.setState({refreshIPBanned: !this.state.refreshIPBanned});
						}}
					/>
					<Collections.IPBanned
						history={this.props.history}
						locations={this.props.locations}
						states={this.props.states}
						reloadShell={this.props.reloadShell}
						reloadPage={() => {
							this.setState({refreshIPBanned: !this.state.refreshIPBanned});
						}}
						reloadSelf={this.state.refreshIPBanned}
						reportAccessListCount={this.reportIpAccessCount}
					/>
				</div>

				<div style={{display: showWhitelist ? 'block' : 'none'}}>
					<h4 className="section-title">
						Whitelist IP Addresses
						{!hasBothModes && (
							<Button data-id="add-ip_whitelist" onClick={this.confirmWhitelistIpOpen} size={"sm"}
								color="primary" style={{float: 'right', marginRight: '-7px'}}>
								<i className="fa fa-check"/>&nbsp;&nbsp;Whitelist IP
							</Button>
						)}
					</h4>
					<UniversalModalOverride
						locations={this.props.locations}
						states={this.props.states}
						history={this.props.history}
						name={"Whitelist IP"}
						object={Objects.IpWhitelists}
						toggle={this.state.modalIPWhitelisted}
						reportClose={this.reportClose('modalIPWhitelisted')}
						afterSave={() => {
							this.setState({refreshIPWhitelisted: !this.state.refreshIPWhitelisted});
						}}
					/>
					<Collections.IPWhitelisted
						history={this.props.history}
						locations={this.props.locations}
						states={this.props.states}
						reloadShell={this.props.reloadShell}
						reloadPage={() => {
							this.setState({refreshIPWhitelisted: !this.state.refreshIPWhitelisted});
						}}
						reloadSelf={this.state.refreshIPWhitelisted}
						reportAccessListCount={this.reportIpAccessCount}
					/>
				</div>
			</div>
		);
	};

	render() {
		const {rootState} = this.props;
		const {hasSecurityModule} = rootState;

		if (!hasSecurityModule) {
			return (
				<Advertisement
					history={this.props.history}
					reloadShell={this.props.reloadShell}
					locations={this.props.locations}
				/>
			);
		}

		return (
			<div className="container-fluid" key={this.state.key}>
				<Framework.Components.PageBar breadcrumbs={breadcrumbsStatic} history={this.props.history}/>

				<div className="row">
					<div className="col-md-8 map-container">

						{/*lockdown and map and login records*/}
						<h4 className="section-title">Lock Down Account</h4>

						Locking down your account will force all sessions logged in to your account into Kiosk Mode or IOI mode.
						Managers and Owners can unlock their screens using the individual PIN setup on their user account.
						Employees & Supervisors will be forced into Kiosk or IOI mode until the account lock as been removed.
						<br/>
						<br/>
						<Button color="danger" onClick={() => this.handleSetPin(1, true)} className="md-button" style={{marginLeft: '0px'}}>
							<i className={"fa fa-lock"}/>&nbsp;&nbsp;Lock Account in Kiosk Mode</Button>

						<Button color="danger" onClick={() => this.handleSetPin(2, true)} className="md-button" style={{marginLeft: '15px'}}>
							<i className={"fa fa-lock"}/>&nbsp;&nbsp;Lock Account in IOI Mode</Button>

						<Button disabled={!rootState.isLockedDown} color={rootState.isLockedDown ? "success" : "secondary"} onClick={() => this.handleSystemUnlock()} className="md-button" style={{marginLeft: '15px', float: "right"}}>
							<i className={"fa fa-unlock"}/>&nbsp;&nbsp;Unlock Account</Button>

						<br/>
						<hr/>
						{/*Screen lock can be triggered for your session by pressing the lock icon in to top right corner of the menu or by pressing the*/}
						{/*"L" button while holding the "Ctrl" button on your keyboard.<br/>*/}
						<br/>
						{/*<h4 className="section-title">Access Map</h4>*/}
						{/*<div id="map"/>*/}
						{/*<br/>*/}

						<h4 className="section-title">Login Records</h4>
						<Collections.LoginRecords
							history={this.props.history}
							locations={this.props.locations}
							states={this.props.states}
							reloadShell={this.props.reloadShell}
							reloadPage={() => {
								this.setState({refreshLoginRecords: !this.state.refreshLoginRecords});
							}}
							reloadSelf={this.state.refreshLoginRecords}
						/>
					</div>
					<div className={"col-md-4"}>

						{/*Two step, password, ips*/}
						<h4 className="section-title">Authenticator App 2FA</h4>
						<Collections.TwoStepAuth
							history={this.props.history}
							locations={this.props.locations}
							states={this.props.states}
							reloadShell={this.props.reloadShell}
							reloadPage={this.refreshPage}
							reloadSelf={this.state.refresh}
						/>


						<h4 className="section-title">Password Complexity</h4>
						<Objects.AccountCustomizationsPassword
							history={this.props.history}
							locations={this.props.locations}
							states={this.props.states}
							reloadShell={this.props.reloadShell}
							reloadPage={this.refreshPage}
							reloadSelf={this.state.refresh}
							noDelete={false}
						/>

						{this.renderIpAccessControl()}

					</div>

				</div>

			</div>
		);
	}
}

export default Framework.Components.withRootState(withRouter(Security));
